import track from 'js/helpers/analytics';

const collectVuelidateErrors = function(obj) {
    return Object.keys(obj.$params).reduce( (errors, field) => {

        const newObj = obj[field]

        if ( typeof newObj === 'object' ) {

            if (newObj.$invalid) {
                return errors.concat( collectVuelidateErrors(newObj) )
            }

        } else if ( newObj === false ) {
            const params = obj.$params[field]
            const msg = (params != null && params.msg) ? params.msg : 'unknown error'
            errors.push(msg)
        }

        return errors

    }, [])

}

export default {

    methods: {
        handleErrorResponse: function(response, defaultMessage) {
            if ( response.status === 422 ) {
                this.handleValidationErrorResponse(response)
            } else {
                track.exception(defaultMessage, response)
                this.$warn(defaultMessage)
            }
        },
        handleValidationErrorResponse: function(response, defaultMessage) {

            if ( response.status !== 422 ) {
                return // not a validation error, should be handled by global error handlers
            }

            let errors = response.body.errors

            if ( errors != null ) {
                errors.forEach( error => this.addFieldError(error.source))
                errors = errors.map( error => error.detail )
                    .filter( error => error != null && error.length > 0 )
            }

            if ( errors == null || errors.length === 0 ) {
                errors = defaultMessage || 'Er is iets mis gegaan'
            }

            this.$warn(errors, { id: 'validation' })
        },
        containsError: function(field) {
            return this.errorFields.includes(field)
        },
        addError: function(field, message) {
            this.errors.push(message)
            this.addFieldError(field)
        },
        addFieldError: function(field) {
            if ( field != null && this.errorFields != null ) {
                this.errorFields.push(field)
            }
        },
        validate: function() {

            this.errors = []
            this.errorFields = []

            // must be implemented  in component
            this.validateFields()
            this.showErrors()

            return this.errors.length === 0

        },
        showErrors: function() {
            if ( this.errors.length > 0 ) {
                this.$warn( this.errors, { id: 'validation' })
            } else {
                this.$hideNotification('validation')
            }
        },
        validateFields: function() {
            // implement in component
        },
        validatePasswordLength: function(password) {
            if ( password == null || password.length < 8 ) {
                this.addError('password', 'Het wachtwoord moet minimaal 8 tekens bevatten')
                return false
            }
            return true
        },
        validatePasswordEqual: function(password, passwordConfirmation) {
            if ( password !== passwordConfirmation ) {
                this.addError('passwordConfirmation', 'De wachtwoorden komen niet overeen')
                return false
            }
            return true
        },
        validateEmail: function(email) {
            if ( ! /\S+@\S+/.test(email) ) {
                this.addError('email', 'Het e-mailadres is ongeldig')
                return false
            }
            return true
        },
        validateCode: function(code) {
            if ( code == null || code.length < 5 ) {
                this.addError('code', 'De klas code is onjuist')
                return false
            }
            return true
        },
        validateFirstName: function(name) {
            if ( name == null || name.length < 1 ) {
                this.addError('firstname', 'Je voornaam is niet ingevuld')
                return false
            }
            return true
        },
        validateLastName: function(name) {
            if ( name == null || name.length < 1 ) {
                this.addError('lastname', 'Je achternaam is niet ingevuld')
                return false
            }
            return true
        },

        validateTerms: function(value) {
            if ( value == null || !value ) {
                this.addError('terms', 'Je moet akkoord gaan met de voorwaarden')
                return false
            }
            return true
        },

        collectVuelidateErrors: function() {
            return collectVuelidateErrors(this.$v)
        },

    },
    beforeDestroy: function() {
        this.$hideNotification('validation')
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/auth/validationMixin.js